export const VIEWER_ACTION_TYPES = {
  VIEWER_IDENTIFIED: 'VIEWER_IDENTIFIED',
  VIEWER_FINISHED: 'VIEWER_FINISHED'
};